// components/clients/ClientCard.jsx
import React from 'react';
import { Tag } from 'antd';
import { StarFilled } from '@ant-design/icons';
import { integer, money } from '../../utils/mobileHelpers';

// Carte de la liste clientes : avatar, identité, métriques selon le mode, pointures.
export const ClientCard = ({ item, mode, onOpen }) => {
  const contact = `${item.client_phone || 'Téléphone à compléter'}${item.commune ? ` · ${item.commune}` : ''}`;
  const periodSummary = [
    `${integer(item.period_net_pairs)} paire(s) nettes`,
    `${integer(item.period_orders)} commande(s)`,
    money(item.period_net_amount),
  ].join(' · ');
  const sizesText = item.preferred_sizes?.length
    ? `Pointures : ${item.preferred_sizes.map((size) => `P${size}`).join(' · ')}`
    : 'Pointures à préciser';

  return (
    <button type="button" className="mobile-client-card" onClick={() => onOpen(item)}>
      <span className="mobile-client-avatar">{item.client_name?.slice(0, 1)?.toUpperCase() || 'C'}</span>
      <div className="mobile-client-copy">
        <div className="mobile-client-name">
          <strong>{item.client_name}</strong>
          {mode === 'best' && <StarFilled />}
          {item.duplicate_phone && <Tag>Doublon téléphone</Tag>}
        </div>
        <small>{contact}</small>
        <em>{mode === 'relance' ? item.relaunch_reason : periodSummary}</em>
        <i>{sizesText}</i>
      </div>
      <div className="mobile-client-side">
        <b>{mode === 'relance' ? `${item.days_since_last_sale} j` : money(item.period_net_amount)}</b>
        <small>{mode === 'relance' ? 'sans achat' : 'période'}</small>
      </div>
    </button>
  );
};
